import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "order-basis-detail" }
const _hoisted_2 = { class: "base__container" }
const _hoisted_3 = { class: "base__item" }
const _hoisted_4 = { class: "base__label" }
const _hoisted_5 = { class: "base__value" }
const _hoisted_6 = { class: "base__item" }
const _hoisted_7 = { class: "base__label" }
const _hoisted_8 = { class: "base__value" }
const _hoisted_9 = { class: "base__item" }
const _hoisted_10 = { class: "base__label" }
const _hoisted_11 = { class: "base__value" }
const _hoisted_12 = { class: "base__item" }
const _hoisted_13 = { class: "base__label" }
const _hoisted_14 = { class: "base__value" }
const _hoisted_15 = { class: "base__item" }
const _hoisted_16 = { class: "base__label" }
const _hoisted_17 = { class: "base__value" }
const _hoisted_18 = { class: "base__item" }
const _hoisted_19 = { class: "base__label" }
const _hoisted_20 = { class: "base__value" }
const _hoisted_21 = { class: "base__item" }
const _hoisted_22 = { class: "base__label" }
const _hoisted_23 = { class: "base__value" }
const _hoisted_24 = { class: "graph__container" }
const _hoisted_25 = { class: "slidebar-multithumb" }
const _hoisted_26 = ["value", "max"]
const _hoisted_27 = ["value", "max"]
const _hoisted_28 = { class: "graph-range-left" }
const _hoisted_29 = { class: "graph-range-right" }
const _hoisted_30 = { class: "next-info__container" }
const _hoisted_31 = { class: "note__container" }
const _hoisted_32 = { class: "note__header" }
const _hoisted_33 = { class: "past-info__container" }

import { equalYearMonthInfo } from '@/appLogic/interfaces/date';
import { changeDayChart } from '@/appLogic/view/orderChart';
import Chart from '@/components/atom/Chart.vue';
import { DAY_NUM_OF_BIZDAYS } from '@/coreDomainsModule/constants';
import { IOrderBasis, IOrderBasisNextMonthlyData } from '@/coreDomainsModule/entities/orderBasis';
import { AnnounceFactory } from '@/coreDomainsModule/factories/announceFactory';
import { ArrivalFactory } from '@/coreDomainsModule/factories/ArrivalFactory';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { OrderBasisService } from '@/coreDomainsModule/services/orderBasisService';
import { UserAccountService } from '@/coreDomainsModule/services/userAccountService';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import { i18n } from '@/i18n';
import { computed, ref, watchEffect } from 'vue';

const TABLE_NUM_CELL_WIDTH = 105;

interface Props {
  basisData?: IOrderBasis;
  sourceOrderId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderBasisDetailSection',
  props: {
    basisData: { default: undefined },
    sourceOrderId: { default: undefined }
  },
  setup(__props: any) {

const t = i18n.t;

const NextMonthlyTableGridTemplateColumn = ['140px', ...new Array(6).fill(`${TABLE_NUM_CELL_WIDTH}px`)];
const PastMonthlyTableGridTemplateColumn = ['66px', ...new Array(12).fill(`${TABLE_NUM_CELL_WIDTH}px`)];

/**
 * コンポーネントのProps定義
 */
const props = __props;

const chartData = ref<any>(undefined);
const chartRange = ref<[number, number]>([0, DAY_NUM_OF_BIZDAYS]);
const chartRangeStartLabel = computed(() => chartData.value?.labels?.[chartRange.value[0]] ?? getGraphRangeLabel(chartRange.value[0]));
const chartRangeEndLabel = computed(
  () => chartData.value?.labels?.[chartRange.value[1] - 1] ?? getGraphRangeLabel(chartRange.value[1] - 1)
);

/**
 * 以後月一覧
 */
const nextMonthlyDates = computed(() => {
  if (!props.basisData || props.basisData.nextMonthlyInfos.length === 0) return [];
  const startYearMonth = props.basisData.nextMonthlyInfos.reduce((acc, current) =>
    DateService.compareYearMonths(acc.orderBasisTargetYearMonth, current.orderBasisTargetYearMonth) === 1 ? current : acc
  ).orderBasisTargetYearMonth;
  return Array.from({ length: 6 }, (_, i) => DateService.getShiftedIYearMonthByMonths(startYearMonth.year, startYearMonth.month, i));
});

/**
 * 以後月次データ
 */
const nextMonthlyInfo = computed(() => {
  return nextMonthlyDates.value.map((month) =>
    props.basisData?.nextMonthlyInfos.find((pmi) => equalYearMonthInfo(pmi.orderBasisTargetYearMonth, month))
  );
});

/**
 * 以前月一覧
 */
const pastMonthlyDates = computed(() => {
  if (!props.basisData || props.basisData.pastMonthlyInfos.length === 0) return [];
  const endYearMonth = props.basisData.pastMonthlyInfos.reduce((acc, current) =>
    DateService.compareYearMonths(acc.orderBasisTargetYearMonth, current.orderBasisTargetYearMonth) === 1 ? acc : current
  ).orderBasisTargetYearMonth;
  return Array.from({ length: 12 }, (_, i) => DateService.getShiftedIYearMonthByMonths(endYearMonth.year, endYearMonth.month, -11 + i));
});

/**
 * 以前月次データ
 */
const pastMonthlyInfo = computed(() => {
  return pastMonthlyDates.value.map((month) =>
    props.basisData?.pastMonthlyInfos.find((pmi) => equalYearMonthInfo(pmi.orderBasisTargetYearMonth, month))
  );
});

const sourceOrderNote = computed(() => {
  return props.basisData?.sourceOrderInfos.find((info) => info.sourceOrderId === props.sourceOrderId)?.snapshotOrderNote?.trim() ?? '';
});
const hasSourceOrderNote = computed(() => sourceOrderNote.value.length > 0);

/**
 * 予入荷を計算して返す
 * @param nextMonthlyData - 以後月次データ
 */
const calcPreArrivalAmount = (nextMonthlyData: IOrderBasisNextMonthlyData | undefined) => {
  if (!nextMonthlyData) return '--';
  return nextMonthlyData.dailyInfos
    .reduce((acc, dailyInfo) => (dailyInfo.snapshotArrivalAmount != null ? (acc += dailyInfo.snapshotArrivalAmount) : acc), 0)
    .addComma();
};

/**
 * グラフ表示範囲の日付ラベル
 * @param offsetDays - シミュレーション開始日からの日数
 */
const getGraphRangeLabel = (offsetDays: number): string => {
  const baseDate = new Date(props.basisData?.snapshotExecutionDate ?? new Date().getTime());
  baseDate.setDate(baseDate.getDate() + offsetDays);

  const yearStr = baseDate.getFullYear();
  const monthStr = baseDate.getMonth() + 1;
  const dayStr = baseDate.getDate();
  let formatStr = 'YYYY-MM-DD';
  formatStr = formatStr.replace(/YYYY/g, yearStr.toString());
  formatStr = formatStr.replace(/MM/g, monthStr.toString());
  formatStr = formatStr.replace(/DD/g, dayStr.toString());
  return formatStr;
};

/**
 * グラフ表示範囲の開始位置を更新する
 * @param event - inputイベント
 */
const onInputChartRangeStart = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = Number(input.value);
  const clampedValue = Math.min(value, chartRange.value[1] - 1);
  chartRange.value[0] = clampedValue;
  input.value = clampedValue.toString();
};

/**
 * グラフ表示範囲の終了位置を更新する
 * @param event - inputイベント
 */
const onInputChartRangeEnd = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = Number(input.value);
  const clampedValue = Math.max(value, chartRange.value[0] + 1);
  chartRange.value[1] = clampedValue;
  input.value = clampedValue.toString();
};

watchEffect(async () => {
  // データがない場合はスキップ
  if (!props.basisData) {
    chartData.value = undefined;
    return;
  }

  // チャート描画
  // 登録済みの入荷snapshotをIArrivalに置き換える
  const expandedArrivalInfos = props.basisData.nextMonthlyInfos.flatMap((nextMonthlyInfo) =>
    nextMonthlyInfo.dailyInfos
      .map((nextDailyInfo) =>
        nextDailyInfo.snapshotArrivalAmount != null
          ? ArrivalFactory.create({
              amount: nextDailyInfo.snapshotArrivalAmount,
              crossDate: { ...nextMonthlyInfo.orderBasisTargetYearMonth, day: nextDailyInfo.orderBasisTargetDay },
              isFixOrdered: true,
            })
          : undefined
      )
      .filter((info) => info != null)
  );
  // 最も納期が後ろの発注済み予入荷を持っておく
  const lastExpandedArrivalInfo = expandedArrivalInfos
    .sort((a, b) => {
      if (!a.crossDate) return -1;
      if (!b.crossDate) return 1;
      return DateService.compareDates(a.crossDate, b.crossDate);
    })
    .at(-1);
  // Chart用のIBusinessを組み立てる
  const graphBusiness = BusinessFactory.create({
    package: props.basisData.snapshotPackage.toString(),
    inventory: props.basisData.snapshotLatestInventoryAmount,
    executionDate: new Date(props.basisData.snapshotExecutionDate),
    MOQ: props.basisData.snapshotMoq,
    customerAnnounceDaily: OrderBasisService.getCustomerAnnounceDailyForChart(props.basisData),
    customerAnnounce: props.basisData.nextMonthlyInfos
      .map((info) =>
        AnnounceFactory.create({
          year: info.orderBasisTargetYearMonth.year,
          month: info.orderBasisTargetYearMonth.month,
          amount: info.snapshotCustomerForecastAmount,
        })
      )
      .concat(
        props.basisData.pastMonthlyInfos.map((info) =>
          AnnounceFactory.create({
            year: info.orderBasisTargetYearMonth.year,
            month: info.orderBasisTargetYearMonth.month,
            amount: info.snapshotCustomerForecastAmount,
          })
        )
      ),
    stdInventoryIndices: { 標準在庫指数: props.basisData.userAdjustedStdInventoryIndex },
    recommend: expandedArrivalInfos,
  });
  // Chart用のExtraSimulateを組み立てる
  const graphExtraSimulate = {
    extraAnnounce: props.basisData.nextMonthlyInfos
      .map((info) =>
        AnnounceFactory.create({
          year: info.orderBasisTargetYearMonth.year,
          month: info.orderBasisTargetYearMonth.month,
          amount: info.userAdjustedCustomerForecastAmount,
        })
      )
      .concat(
        props.basisData.pastMonthlyInfos.map((info) =>
          AnnounceFactory.create({
            year: info.orderBasisTargetYearMonth.year,
            month: info.orderBasisTargetYearMonth.month,
            amount: info.snapshotCustomerForecastAmount,
          })
        )
      ),
    extraStartDate: lastExpandedArrivalInfo?.crossDate
      ? new Date(
          DateService.convertIDateToUnixTime(
            DateService.getShiftedIYearMonthByDays(
              lastExpandedArrivalInfo.crossDate.year,
              lastExpandedArrivalInfo.crossDate.month,
              lastExpandedArrivalInfo.crossDate.day,
              1
            )
          )
        )
      : new Date(props.basisData.snapshotExecutionDate),
    extraLeadTime: props.basisData.userAdjustedLeadTime.value,
    extraStdInventory: props.basisData.userAdjustedStdInventoryIndex,
    extraRecommend: expandedArrivalInfos,
  };
  // Chart用にシュミレートを回す
  chartData.value = await changeDayChart(
    graphBusiness,
    null,
    DAY_NUM_OF_BIZDAYS,
    0,
    DateService.convertDateToIDate(new Date(props.basisData.snapshotExecutionDate)),
    props.basisData.snapshotSimulationSetting,
    graphExtraSimulate
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('商品')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(`${_ctx.basisData?.snapshotBusinessNumber ?? '--'} / ${_ctx.basisData?.snapshotBusinessName ?? '--'}`), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('仕入先')), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(`${_ctx.basisData?.snapshotSupplierNumber ?? '--'} / ${_ctx.basisData?.snapshotSupplierName ?? '--'}`), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('容量')), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.basisData?.snapshotPackage.addComma()), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('製造社')), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.basisData?.snapshotManufacturer ?? '--'), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('MOQ')), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.basisData?.snapshotMoq?.addComma() ?? '--'), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('発注単位')), 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.basisData?.snapshotOrderPackage?.addComma() ?? '--'), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('担当者')), 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(UserAccountService).getDisplayUsers(_ctx.basisData?.snapshotResponsibleUsers ?? [])), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(Chart, {
        "date-unit": 'day',
        styles: {
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
        },
        "chart-data": chartData.value,
        "chart-height": "260px",
        start: chartRange.value[0],
        end: chartRange.value[1]
      }, null, 8, ["chart-data", "start", "end"]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("input", {
          id: "range-0",
          value: chartRange.value[0],
          class: "thumb-0",
          type: "range",
          name: "range-0",
          min: "0",
          max: _unref(DAY_NUM_OF_BIZDAYS) - 1,
          step: "1",
          onInput: onInputChartRangeStart
        }, null, 40, _hoisted_26),
        _createElementVNode("input", {
          id: "range-1",
          value: chartRange.value[1],
          class: "thumb-1",
          type: "range",
          name: "range-1",
          min: "1",
          max: _unref(DAY_NUM_OF_BIZDAYS),
          step: "1",
          onInput: onInputChartRangeEnd
        }, null, 40, _hoisted_27),
        _createElementVNode("span", _hoisted_28, _toDisplayString(chartRangeStartLabel.value), 1),
        _createElementVNode("span", _hoisted_29, _toDisplayString(chartRangeEndLabel.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(EzTable, {
        class: "table",
        "grid-template-columns": NextMonthlyTableGridTemplateColumn,
        "sticky-header": "",
        "sticky-left-columns": ""
      }, {
        header: _withCtx(() => [
          _createVNode(EzHeader, { class: "table--header table--left-header" }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyDates.value, (header, index) => {
            return (_openBlock(), _createBlock(EzHeader, {
              key: `table-next-header-${index}`,
              class: "table--header"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(DateService).convertIYearMonthToYYYYMMWithSlash(header, true)), 1)
              ], undefined, true),
              _: 2
            }, 1024))
          }), 128))
        ]),
        body: _withCtx(() => [
          _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell table--left-header",
                "content-padding": 8
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('予入荷')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(calcPreArrivalAmount(targetMonthBasis)), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell table--left-header",
                "content-padding": 8
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('オリジナル内示')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotCustomerForecastAmount.addComma() ?? '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell table--left-header",
                "content-padding": 8
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('シミュレーション内示')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis?.userAdjustedCustomerForecastAmount.addComma() ?? '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell table--left-header",
                "content-padding": 8
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('予末在庫')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotPreInventoryAmount.addComma() ?? '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell table--left-header",
                "content-padding": 8
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('在庫回転率')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "force-right": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis && targetMonthBasis.snapshotCustomerForecastAmount !== 0
                    ? (targetMonthBasis.snapshotPreInventoryAmount / targetMonthBasis.snapshotCustomerForecastAmount).roundToDecimal(2)
                    : '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('メモ')), 1),
      _createElementVNode("p", {
        class: _normalizeClass(["note__body", { 'note__body--empty': !hasSourceOrderNote.value }])
      }, _toDisplayString(hasSourceOrderNote.value ? sourceOrderNote.value : _unref(t)('メモはありません')), 3)
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(EzTable, {
        class: "table",
        "grid-template-columns": PastMonthlyTableGridTemplateColumn,
        "sticky-header": ""
      }, {
        header: _withCtx(() => [
          _createVNode(EzHeader, {
            class: "table--header",
            sticky: "left"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyDates.value, (header, index) => {
            return (_openBlock(), _createBlock(EzHeader, {
              key: `table-past-header-${index}`,
              class: "table--header"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(DateService).convertIYearMonthToYYYYMMWithSlash(header, true)), 1)
              ], undefined, true),
              _: 2
            }, 1024))
          }), 128))
        ]),
        body: _withCtx(() => [
          _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell",
                "content-padding": 8,
                sticky: "left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('販売実績')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotSalesResultAmount.addComma() ?? '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell",
                "content-padding": 8,
                sticky: "left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('内示')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotCustomerForecastAmount.addComma() ?? '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell",
                "content-padding": 8,
                sticky: "left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('正答率')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "force-right": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis && targetMonthBasis.snapshotCustomerForecastAmount !== 0
                    ? ((targetMonthBasis.snapshotSalesResultAmount / targetMonthBasis.snapshotCustomerForecastAmount) * 100).roundToDecimal(
                        2
                      ) + '%'
                    : '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
            default: _withCtx(() => [
              _createVNode(EzCell, {
                class: "table--cell",
                "content-padding": 8,
                sticky: "left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('在庫')), 1)
                ], undefined, true),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                return (_openBlock(), _createBlock(EzCell, {
                  key: index,
                  class: "table--cell",
                  "is-number": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotInventoryAmount.addComma() ?? '--'), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ], undefined, true),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})